export default [
    {
        type: "uni",
        id: 1,
        items: [
            {
                id: 1,
                text: "Der Dozent/Die Dozentin war engagiert und motiviert.",
            },
            {
                id: 2,
                text: "Der Dozent hat die Inhalte angemessen wiederholt.",
            },
            {
                id: 3,
                text: "Ich konnte dem Tempo des Dozenten/der Dozentin gut folgen.",
            },
            {
                id: 4,
                text: "Der Dozent/Die Dozentin ermöglichte eine gute Lern- und Arbeitsatmosphäre.",
            },
            {
                id: 5,
                text: "Der Dozent/Die Dozentin gab die Möglichkeit, Themen zu diskutieren.",
            },
            {
                id: 6,
                text: "Der Dozent/Die Dozentin war stets gut vorbereitet.",
            },
            {
                id: 7,
                text: "Der Dozent/Die Dozentin war fachlich kompetent.",
            },
            {
                id: 8,
                text: "Der Dozent/Die Dozentin konnte Kompliziertes verständlich machen.",
            },
            {
                id: 9,
                text: "Dem Dozenten/Der Dozentin war es wichtig, dass die Teilnehmer/innen etwas lernen.",
            },
            {
                id: 10,
                text: "Der Dozent/Die Dozentin motivierte die Teilnehmer/innen.",
            },
            {
                id: 11,
                text: "Das Lernziel wurde mir deutlich.",
            },
            {
                id: 12,
                text: "Die angestrebten Lernziele wurden von vorneherein gut definiert.",
            },
            {
                id: 13,
                text: "Die Übung war übersichtlich und verständlich.",
            },
            {
                id: 14,
                text: "Der inhaltliche Aufbau der Übung war logisch/nachvollziehbar.",
            },
            {
                id: 15,
                text: "Ich habe mich schon vor der Übung für das Thema interessiert.",
            },
            {
                id: 16,
                text: "Das erforderliche Vorwissen ist angemessen.",
            },
            {
                id: 17,
                text: "Die Anteile mathematischer/technischer Inhalte sind angemessen.",
            },
            {
                id: 18,
                text: "Das Thema der Übung ist als solches relevant.",
            },
            {
                id: 19,
                text: "Ich habe das Gefühl in der Übung Wichtiges gelernt zu haben.",
            },
            {
                id: 20,
                text: "Das behandelte Thema enthält Bezüge zu meiner späteren Berufstätgkeit.",
            },
            {
                id: 21,
                text: "Die Schwere des Stoffes war angemessen.",
            },
            {
                id: 22,
                text: "Der Umfang des Stoffes war angemessen.",
            },
            {
                id: 23,
                text: "Das Tempo der Übung war angemessen.",
            },
            {
                id: 24,
                text: "Die Anforderungen der Übung waren angemessen.",
            },
            {
                id: 25,
                text: "Der Zeitaufwand für die Übung insgesamt (inkl. Vor- und Nachbereitung) war angemessen.",
            },
            {
                id: 26,
                text: "Insgesamt hat mich die Übung überfordert.",
            },
            {
                id: 27,
                text: "Ich habe mich durch die Übung unterfordert gefühlt.",
            },
            {
                id: 28,
                text: "Die Qualität der in der Übung verwendeten Medien war gut.",
            },
            {
                id: 29,
                text: "Es wurden genügend Materialien zur Vertiefung des Stoffes angeboten.",
            },
            {
                id: 30,
                text: "Folien und Skripte waren rechtzeitig zugänglich.",
            },
            {
                id: 31,
                text: "Die vorbereiteten Folien trugen zum Verständnis der Inhalte bei.",
            },
            {
                id: 32,
                text: "Die verfügbaren Materialien waren optimal dazu geeignet, die Übung nachzuarbeiten.",
            },
            {
                id: 33,
                text: "Die Übung war für mich hilfreich.",
            },
            {
                id: 34,
                text: "Die Übung hat mein Verständnis der Inhalte vertieft.",
            },
            {
                id: 35,
                text: "Zur kritischen Auseinandersetzung mit den behandelten Themen wurde ich durch die Übung angeregt.",
            },
            {
                id: 36,
                text: "Der Stoff wurde innerhalb der Übung anhand von Beispielen veranschaulicht.",
            },
            {
                id: 37,
                text: "Die Bedeutung der behandelten Themen wurde innerhalb der Übung vermittelt.",
            },
            {
                id: 38,
                text: "Ein Bezug zwischen Theorie und Praxis/Anwendung wurde innerhalb der Übung hergestellt.",
            },
            {
                id: 39,
                text: "Insgesamt fand ich die Übung gut.",
            },
            {
                id: 40,
                text: "In der Übung habe ich viel gelernt.",
            },
            {
                id: 41,
                text: "Meine Erwartungen an die Übung wurden erfüllt.",
            },
            {
                id: 42,
                text: "Ich würde die Übung weiterempfehlen.",
            },
        ],
    },
    {
        type: "special",
        id: 2,
        items: [
            {
                id: 43,
                text: "Insgesamt bewerte ich die Übung mit der Note",
                label: [
                    {
                        id: 1,
                        text: "sehr gut",
                    },
                    {
                        id: 2,
                        text: "gut",
                    },
                    {
                        id: 3,
                        text: "befriedigend",
                    },
                    {
                        id: 4,
                        text: "ausreichend",
                    },
                    {
                        id: 5,
                        text: "mangelhaft",
                    },
                ],
            },
        ],
    },
    {
        type: "text",
        id: 3,
        items: [
            {
                id: 44,
                text: "Sonstige Anmerkungen zu der Veranstaltung (Lob/Kritik)",
            },
        ],
    },
    {
        type: "age",
        id: 4,
        items: [
            {
                id: 45,
                text: "Alter: ",
            },
        ],
    },
];